import axios from 'axios'

// Interceptor for handling response errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      sessionStorage.clear()
    }
    return Promise.reject(error);
  }
);

const get = ({ jwt, project, pageSize, page }) => {
  const config = {
    params: { hash_id_widget_completed_form: project, page_size: pageSize, page: page},
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'x-auth-token': jwt
    }
  }
  return axios.get('/api/project-log', config)
}

const post = ({ jwt, payload }) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'x-auth-token': jwt
    }
  }
  return axios.post('/api/project-log/role-type-log', payload, config)
}

const projectLogAPI = { get, post }
export default projectLogAPI